import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { otherComplaintsKey } from "./SymptomModules";
import OtherSymptomInput from "./OtherSymptomInput";

const SymptomParams = ({
  symptomParams,
  setSymptomParams,
  category,
  onSymptomParamsSelected,
}) => {
  const { t } = useTranslation();
  const [sortedParams, setSortedParams] = useState([]);
  const [selectedParams, setSelectedParams] = useState([]);

  useEffect(() => {
    const updatedSelectedParams = symptomParams?.filter((param) =>
      selectedParams.some((p) => p?.term === param?.term),
    );

    setSortedParams(symptomParams?.sort((a, b) => {
      if (t(a.term) < t(b.term)) return -1;
      if (t(a.term) > t(b.term)) return 1;
      return 0;
    }));

    setSelectedParams(updatedSelectedParams);
  }, [symptomParams]);

  const checkRequiredFields = () => {
    return selectedParams.length > 0;
  };

  function handleSelectSymptomElem(e, param) {
    if (e.target.checked) {
      setSelectedParams((prevSelected) => [...prevSelected, param]);
    } else {
      setSelectedParams((prevSelected) =>
        prevSelected?.filter((p) => p?.term !== param?.term),
      );
    }
  }

  function handleAddNewOtherComplaints(symptom) {
    const updatedSymptoms = [...symptomParams, symptom];
    setSymptomParams(updatedSymptoms);

    setSelectedParams((prevSelected) => {
      if (!prevSelected.some((p) => p?.term === symptom?.term)) {
        return [...prevSelected, symptom];
      }

      return prevSelected;
    });
  }

  return (
    <>
      <header className="w3-container w3-padding-small w3-center">
        <p>{t(category)}</p>
        <p>{t("please_select_the_symptom_parameters")}</p>
      </header>
      {category === otherComplaintsKey && (
        <OtherSymptomInput
          onAddNewSymptomParam={handleAddNewOtherComplaints}
          symptomsList={symptomParams}
        />
      )}
      <div className="w3-container form-content-scroll">
        {sortedParams?.map((elem, i) => {
          const label = t(elem.term);

          return (
            <div className="w3-container" key={`elem${i}`}>
              <FormControlLabel
                label={<label>{label}</label>}
                labelPlacement="end"
                control={
                  <Checkbox
                    value={elem.term}
                    checked={selectedParams.some((p) => p.term === elem.term)}
                    onChange={(e) => handleSelectSymptomElem(e, elem)}
                  />
                }
              />
            </div>
          );
        })}
      </div>
      <footer className="w3-container">
        <div className="w3-right">
          <button
            onClick={() => onSymptomParamsSelected(selectedParams)}
            type="button"
            className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin"
            disabled={!checkRequiredFields()}
          >
            {t("submit")}
          </button>
          <button
            onClick={() => onSymptomParamsSelected(null)}
            className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin"
            type="button"
          >
            {t("cancel")}
          </button>
        </div>
      </footer>
    </>
  );
};

export default SymptomParams;
